const qualityProgressReducer = (data = {}, action) => {
    switch(action.type){
        case 'SET_QUALITY_PROGRESS':
            data = action.data
            return data;
        default:
            return data;
    }
}

export default qualityProgressReducer;